import type CK from '~/types/contentking';

import {
	usePageLastUnreliableResponseQuery,
} from './usePageLastUnreliableResponse.gql';

import usePageDetailPropertiesQuery from '~/hooks/usePageDetailPropertiesQuery';



function usePageLastUnreliableResponse(
	legacyUrlId: number,
	websiteId: CK.WebsiteId,
) {
	const { data } = usePageDetailPropertiesQuery(
		usePageLastUnreliableResponseQuery,
		legacyUrlId,
		websiteId,
	);

	return data?.lookupPageByLegacyId?.lastUnreliableResponse ?? null;
}



export default usePageLastUnreliableResponse;
